import truncate from "lodash/truncate";
import PropTypes from "prop-types";
import { Form, Icon, Label } from "semantic-ui-react";

import "./file-upload.scss";

export const FileUpload = ({
  resourceUrl = null,
  resourceFilename = null,
  uploadLabelText,
  disableFileCta,
  fieldName,
  onFileRemove,
  onPick,
  size = "large",
}) =>
  resourceUrl ? (
    <Label className="file-upload-label" size={size}>
      {truncate(resourceFilename, { length: 30 })}
      <Icon name="delete" onClick={onFileRemove} />
    </Label>
  ) : (
    <Form.Button
      fluid
      basic
      secondary
      icon
      disabled={disableFileCta}
      labelPosition="left"
      name={fieldName}
      onClick={onPick}
      content={
        <span
          style={{ float: "left", fontWeight: "lighter", color: "#000" }}
          className="file-upload-wrapper"
        >
          <Icon name="file" />
          {uploadLabelText}
        </span>
      }
    />
  );

FileUpload.propTypes = {
  onPick: PropTypes.func.isRequired,
  onFileRemove: PropTypes.func.isRequired,
  uploadLabelText: PropTypes.string.isRequired,
  resourceUrl: PropTypes.string,
  resourceFilename: PropTypes.string,
  size: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  disableFileCta: PropTypes.bool.isRequired,
};
